module.exports = __webpack_public_path__ + "img/img-archive06.3c3c0970.png";